<ion-content class="popover" id="yes-no-popup">
  <ion-list>
    <ion-list-header>
      <!--Fall1 Aktivierungsmail erneut versenden?-->
      <h2 *ngIf="questionType==='send-activation-mail'">
        {{'send-activation-mail-popover.account-notactivated_1' |translate}}
        {{userMail}}
        {{'send-activation-mail-popover.account-notactivated_2' |translate}}
      </h2>
      <!--Fall2 Rauchprotokoll fortsetzen?-->
      <h2 *ngIf="questionType==='continue-smoking-protocol'">
        {{'continue-popover.continue' |translate}}?
      </h2>
      <!--Fall3 Antrag für Anlegen neue Zigarre?-->
      <h2 *ngIf="questionType==='new-cigar-na'">
        <p>
        {{'yes-no-popup.new-cigar-na_1' |translate}}
        </p>
        <p>
        {{'yes-no-popup.new-cigar-na_2' |translate}}
        </p>
        <p>
        {{'yes-no-popup.new-cigar-na_3' |translate}}
        </p>
      </h2>
      <!--Fall4 Antrag Cigarrendaten ändern?-->
      <h2 *ngIf="questionType==='update-cigar-na'">
        <p>
        {{'yes-no-popup.update-cigar-na_1' |translate}}
        </p>
        <p>
        {{'yes-no-popup.update-cigar-na_2' |translate}}
        </p>
        <p>
        {{'yes-no-popup.update-cigar-na_3' |translate}}
        </p>
      </h2>
      <!--Fall5 Zigarren nach Rauchprotokoll entfernen?-->
      <h2 *ngIf="questionType==='remove-entry-after-sp'">
        <p>
        {{'yes-no-popup.remove-entry-after-sp_1' |translate}}
        {{cigarName}}
        {{'yes-no-popup.remove-entry-after-sp_2' |translate}}
        </p>
      </h2>
      <!--Fall6 Humidor-Eintrag wirklich löschen?-->
      <h2 *ngIf="questionType==='really-delete'">
        {{'yes-no-popup.really-delete_1' |translate}}
        <br>
        <br>
        <span class="advice">
        {{'yes-no-popup.really-delete_2' |translate}}
        </span>
        <br>
        <br>
        <span class="advice">
        {{'yes-no-popup.really-delete_3' |translate}}
        </span>
      </h2>
      <!--Fall7 Humidor wirklich löschen?-->
      <h2 *ngIf="questionType==='really-delete-humi'">
        {{'yes-no-popup.really-delete-humi_1' |translate}}
        <br>
        <br>
        <span class="advice">
        {{'yes-no-popup.really-delete-humi_2' |translate}}
        </span>
      </h2>
      <!--Fall8 Konto wirklich löschen?-->
      <h2 *ngIf="questionType==='really-delete-account'">
        {{'yes-no-popup.really-delete-account_1' |translate}}
        <br>
        <br>
        <span class="advice">
        {{'yes-no-popup.really-delete-account_2' |translate}}
        <p>
          {{'yes-no-popup.really-delete-account_3' |translate}}
        </p>
        </span>
      </h2>
      <!--Fall9 Humidor-Kapazität kaufen?-->
      <h2 *ngIf="questionType==='wanna-buy-capacity'">
        {{'yes-no-popup.wanna-buy-capacity_1' |translate}}
        <br>
        <br>
        <span class="advice">
        {{'yes-no-popup.wanna-buy-capacity_2' |translate}}
        </span>
      </h2>
      <!--Fall10 Rauchprotokoll nach Schliessen des Modal löschen?-->
      <h2 *ngIf="questionType==='delete-sp'">
        {{'yes-no-popup.delete-sp_1' |translate}}
        <br>
        <br>
        <span class="advice">
        {{'yes-no-popup.delete-sp_2' |translate}}
        </span>
      </h2>
      <!--Fall11 Rauchprotokoll aus Liste wirklich löschen?-->
      <h2 *ngIf="questionType==='delete-sp-from-list'">
        {{'yes-no-popup.delete-sp-from-list' |translate}}
      </h2>
      <!--Fall12 Daten aus vorhandenen Rauchprotokollen übernehmen? -->
      <h2 *ngIf="questionType==='get-params-from-several-former-sp'">
        {{'yes-no-popup.get-params-from-several-former-sp' |translate}}
      </h2>
      <!--Fall13 Daten aus vorhandenem Rauchprotokoll übernehmen? -->
      <h2 *ngIf="questionType==='get-params-from-single-former-sp'">
        {{'yes-no-popup.get-params-from-single-former-sp' |translate}}
      </h2>
      <!--Fall14 Aroma aus vorhandenem Rauchprotokoll löschen? -->
      <h2 *ngIf="questionType==='delete-aroma-from-sp'">
        {{'yes-no-popup.really-delete-aroma' |translate}}
      </h2>
      <!--Fall15 Bild von Rauchprotokollen auf Server synchronisieren? -->
      <h2 *ngIf="questionType==='sync-prot-images'">
        {{'yes-no-popup.sync-prot-images' |translate}}
      </h2>
      <!--Fall16 Wirklich ausloggen? (Nutzer landet mit Back-Button auf Login)-->
      <h2 *ngIf="questionType==='really-logout'">
        {{'yes-no-popup.really-logout' |translate}}
      </h2>
      <!--Fall17 History Eintrag wirklich löschen? -->
      <h2 *ngIf="questionType==='delete-history-entry'">
        {{'yes-no-popup.really-delete_1' |translate}}
      </h2>
      <!--Fall 18 CSV Export senden?-->
      <h2 *ngIf="questionType==='really-send-csv'">
        {{'yes-no-popup.really-send-csv' |translate}}
      </h2>
      <h2 *ngIf="questionType==='install-pwa'">
        {{'yes-no-popup.install-pwa' |translate}}
      </h2>
      <!--Fall 19 PWA Paypal kündigen ?-->
      <h2 *ngIf="questionType==='cancel-paypal'">
        {{'yes-no-popup.cancel-paypal' |translate}}
      </h2>
    </ion-list-header>
    <!--Checkbox für Fall6 (Warnung nicht mehr anzeigen)-->
    <ion-item lines="none" *ngIf="questionType==='really-delete'" class="popoverbc" color="primary-contrast">
      <ion-grid>
        <ion-row>
          <ion-col size="2" id="checkbox_col">
            <ion-checkbox id="show_message" (click)="toggleNo()">
            </ion-checkbox>
          </ion-col>
          <ion-col size="10">
            <span id="check_advice">
              {{'yes-no-popup.show-in-future' |translate}}
            </span>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>
    <ion-item lines="none" class="popoverbc" color="primary-contrast">
      <ion-button size="medium" slot="start" color="success" (click)="answer(true)" id="yes-button">
        {{'continue-popover.yes' |translate}}
      </ion-button>
      <ion-button size="medium" slot="end" color="danger" (click)="answer(false)" id="no-button">
        {{'continue-popover.no' |translate}}
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
